import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface MetricCardProps {
  label: string;
  value: string;
  icon: React.ReactNode;
  color?: string;
}

export function MetricCard({ label, value, icon, color = "primary" }: MetricCardProps) {
  return (
    <div className="col">
      <div className="apple-card gestalt-group group border-0 shadow-sm rounded-5 p-5 w-100 h-100">
        <div className="d-flex align-items-center w-100">
          <div className={`p-3 rounded-circle shadow-apple-sm bg-${color} flex-shrink-0`}>
            {icon}
          </div>
          <div className="ms-3 min-w-0 flex-grow-1">
            <p className="fs-6 text-uppercase text-gray-900 fw-semibold mb-0 text-truncate">
              {label}
            </p>
            {value ? <OverlayTrigger
              placement="auto"
              overlay={<Tooltip>{value}</Tooltip>}
            >
              <p className="fs-4 fw-bold text-gray-900 mb-0 text-truncate cursor-pointer">
                {value || '-'}
              </p>
            </OverlayTrigger> :
              <p className="fs-4 fw-bold text-gray-900 mb-0 text-truncate">
                -
              </p>}
          </div>
        </div>
      </div>
    </div>
  );
}
